import type { KPIFormValues } from "./KPIForm";

export const kpiFormSamples: KPIFormValues[] = [
  {
    name: "ອັດຕາການມາທຳວຽກຕາມເວລາ",
    description: "ວັດແທກຈຳນວນພະນັກງານທີ່ມາທຳວຽກຕາມເວລາທີ່ກຳນົດ",
    level: "employee",
    measurementMethod: "ນັບຈາກການເຊັກອິນໃນລະບົບ ແລະ ກວດສອບເວລາມາເຮັດວຽກ",
    measurementSource: "ລະບົບເຊັກອິນ, ໃບເຊັກອິນ",
    measurementPeriod: "monthly",
    targetValue: 95,
    targetUnit: "percent",
    passCriteria: ">= 95%",
    failCriteria: "< 90%",
    notes: "ບໍ່ນັບວັນລາພັກ ຫຼື ວັນລາພັກປະຈຳປີ\nຖ້າມີໂອກາດພິເສດໃຫ້ແຈ້ງລ່ວງໜ້າ",
    status: "active",
  },
  {
    name: "ຈຳນວນການສຳເລັດການກວດສອບ Checklist",
    description: "ວັດແທກຈຳນວນ Checklist ທີ່ສຳເລັດການກວດສອບໃນແຕ່ລະເດືອນ",
    level: "employee",
    measurementMethod: 'ນັບຈາກລະບົບ Checklist ທີ່ມີສະຖານະ "ສຳເລັດ" ໃນເດືອນ',
    measurementSource: "ລະບົບ Checklist",
    measurementPeriod: "monthly",
    targetValue: 100,
    targetUnit: "percent",
    passCriteria: "= 100%",
    failCriteria: "< 80%",
    notes: "ບໍ່ນັບ Checklist ທີ່ຖືກຍົກເລີກການມອບໝາຍ",
    status: "active",
  },
  {
    name: "ຈຳນວນຄວາມຜິດພາດໃນການຈັດການຂໍ້ມູນ",
    description: "ວັດແທກຈຳນວນຄວາມຜິດພາດທີ່ເກີດຈາກການຈັດການຂໍ້ມູນທີ່ບໍ່ຖືກຕ້ອງ",
    level: "employee",
    measurementMethod: "ນັບຈາກການລາຍງານຂໍ້ຜິດພາດ ແລະ ການກວດສອບຄຸນນະພາບຂໍ້ມູນ",
    measurementSource: "ລະບົບລາຍງານ, ການກວດສອບຄຸນນະພາບ",
    measurementPeriod: "monthly",
    targetValue: 5,
    targetUnit: "count",
    passCriteria: "<= 5 ຄັ້ງ",
    failCriteria: "> 10 ຄັ້ງ",
    notes: "ຄວາມຜິດພາດທີ່ເກີດຈາກລະບົບບໍ່ໄດ້ນັບ\nຕ້ອງມີການດູແລປ່ຽນແປງແບບທັນທີ",
    status: "active",
  },
  {
    name: "ອັດຕາການສຳເລັດວຽກຕາມແຜນ",
    description: "ວັດແທກຈຳນວນໂຄງການ ຫຼື ວຽກທີ່ສຳເລັດຕາມຜະແນການທີ່ກຳນົດໄວ້",
    level: "department",
    measurementMethod: "ຄິດໄລ່ຈາກຈຳນວນວຽກທີ່ສຳເລັດຕໍ່ຈຳນວນວຽກທັງໝົດທີ່ກຳນົດໃນແຜນ",
    measurementSource: "ລະບົບການຈັດການໂຄງການ, ຜະແນການເຮັດວຽກ",
    measurementPeriod: "monthly",
    targetValue: 90,
    targetUnit: "percent",
    passCriteria: ">= 90%",
    failCriteria: "< 80%",
    notes: "ຖ້າມີການປ່ຽນແປງແຜນໃຫ້ອັບເດດຜະແນກ່ອນການວັດແທກ\nບໍ່ນັບວຽກທີ່ຖືກຍົກເລີກຈາກແຜນ",
    status: "active",
  },
  {
    name: "ການຫຼຸດຜ່ອນຄວາມຜິດພາດ",
    description: "ວັດແທກການຫຼຸດຜ່ອນຈຳນວນຄວາມຜິດພາດທີ່ເກີດຂຶ້ນໃນການເຮັດວຽກ",
    level: "department",
    measurementMethod:
      "ປຽບທຽບຈຳນວນຄວາມຜິດພາດລະຫວ່າງໄລຍະເວລາ ແລະ ຄິດໄລ່ອັດຕາການຫຼຸດຜ່ອນ",
    measurementSource: "ລະບົບລາຍງານຄວາມຜິດພາດ, ການກວດສອບຄຸນນະພາບ",
    measurementPeriod: "quarterly",
    targetValue: 10,
    targetUnit: "percent",
    passCriteria: ">= 10%",
    failCriteria: "< 5%",
    notes: "ຕ້ອງມີການວາງແຜນປັບປຸງຢ່າງຊັດເຈນ\nຖ້າມີການປ່ຽນແປງຂະບວນການໃຫ້ບັນທຶກໄວ້",
    status: "active",
  },
  {
    name: "ຈຳນວນການຮ້ອງທຸກຈາກລູກຄ້າ",
    description: "ວັດແທກຈຳນວນການຮ້ອງທຸກ ຫຼື ຄຳຕິຊົມທີ່ໄດ້ຮັບຈາກລູກຄ້າ",
    level: "department",
    measurementMethod: "ນັບຈາກລະບົບຮ້ອງທຸກ ແລະ ຊ່ອງທາງການຕິດຕໍ່ກັບລູກຄ້າ",
    measurementSource: "ລະບົບຮ້ອງທຸກ, ອີເມວ, ໂທລະສັບ",
    measurementPeriod: "monthly",
    targetValue: 3,
    targetUnit: "count",
    passCriteria: "<= 3 ຄັ້ງ",
    failCriteria: "> 5 ຄັ້ງ",
    notes: "ບໍ່ນັບການຮ້ອງທຸກທີ່ບໍ່ສົມບູນ ຫຼື ເປັນການຮ້ອງທຸກທີ່ບໍ່ສົມຂໍ້ກຳນົດ\nຕ້ອງມີການດູແລແກ້ໄຂບັນຫາທັນທີ",
    status: "active",
  },
  {
    name: "ຍອດຂາຍທັງໝົດ",
    description: "ວັດແທກຍອດຂາຍລວມທັງໝົດຂອງອົງກອນໃນແຕ່ລະໄລຍະເວລາ",
    level: "organization",
    measurementMethod: "ຄິດໄລ່ຈາກຍອດຂາຍທັງໝົດທີ່ບັນທຶກໃນລະບົບບັນຊີ",
    measurementSource: "ລະບົບບັນຊີ, ລາຍງານການເງິນ",
    measurementPeriod: "monthly",
    targetValue: 5,
    targetUnit: "percent",
    passCriteria: ">= 5%",
    failCriteria: "< 2%",
    notes:
      "ຕ້ອງປຽບທຽບກັບໄລຍະເວລາດຽວກັນໃນປີກ່ອນໜ້າເພື່ອກຳນົດການເຕີບໂຕ\nບໍ່ນັບລາຍໄດ້ຈາກການຂາຍຊັບສິນຖາວອນ",
    status: "active",
  },
  {
    name: "ຄວາມພໍໃຈຂອງລູກຄ້າ",
    description: "ວັດແທກຄວາມພໍໃຈຂອງລູກຄ້າຕໍ່ການບໍລິການ",
    level: "organization",
    measurementMethod: "ສຳຫຼວດລູກຄ້າຜ່ານແບບສຳຫຼວດ ແລະ ຄິດໄລ່ຄະແນນເ averaged",
    measurementSource: "ແບບສຳຫຼວດ, ການປະເມີນຜົນຈາກລູກຄ້າ",
    measurementPeriod: "quarterly",
    targetValue: 4.0,
    targetUnit: "score",
    passCriteria: ">= 4.0 ຄະແນນ",
    failCriteria: "< 3.5 ຄະແນນ",
    notes:
      "ຕ້ອງມີການສຳຫຼວດຢ່າງສະໝ່ຳສະເໝີ ແລະ ມີຈຳນວນຕົວຢ່າງພໍສົມຄວນ\nຖ້າມີຄຳຕິຊົມໃຫ້ດູແລແກ້ໄຂບັນຫາທັນທີ",
    status: "active",
  },
  {
    name: "ການຫຼຸດລົງຂອງຕົ້ນທຶນ",
    description: "ວັດແທກການຫຼຸດລົງຂອງຕົ້ນທຶນດ້ານການດຳເນີນງານ",
    level: "organization",
    measurementMethod: "ປຽບທຽບຕົ້ນທຶນລະຫວ່າງໄລຍະເວລາ ແລະ ຄິດໄລ່ອັດຕາການຫຼຸດລົງ",
    measurementSource: "ລະບົບບັນຊີ, ລາຍງານການເງິນ",
    measurementPeriod: "quarterly",
    targetValue: 5,
    targetUnit: "percent",
    passCriteria: ">= 5%",
    failCriteria: "< 2%",
    notes:
      "ຕ້ອງຄຳນຶງເຖິງການປັບປຸງຄຸນນະພາບການບໍລິການຄຽງຄູ່ກັບການຫຼຸດຕົ້ນທຶນ\nບໍ່ຄວນຫຼຸດຕົ້ນທຶນໂດຍການຫຼຸດຄຸນນະພາບ",
    status: "active",
  },
];
